<template>
  <div>
    <el-dialog :title="source ==='login' ? '绑定账号' : '添加组织账号'" :visible.sync="dialogVisible" width="590px" class="custom_dialog" @close="clearData">
      <div class="content">
        <el-form ref="form" :rules="rules" :model="formData" label-width="100px" class="custom_my_form">
          <el-form-item label="账号" prop="account">
            <el-input v-model="formData.account" placeholder="请输入账号" size="medium" maxlength=20 style="width: 280px;"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" class="code">
            <el-input v-model="formData.password" placeholder="请输入账号" size="medium" maxlength=20 style="width: 280px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <p class="custom_my_btn" @click="save">{{source ==='login' ?'绑定并登录':'保 存'}}</p>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
let resloveFun = (data) => { }
let rejectFun = (data) => { }
import * as api from '@/api'
export default {
  name: 'bindOrganizationalAccount',
  data() {
    return {
      dialogVisible: false,
      formData: {
        account: '',
        password: '',
      },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      source: 'default',
    }
  },
  methods: {
    showDialog(source = 'default') {
      return new Promise((resolve, reject) => {
        resloveFun = (data) => resolve(data)
        rejectFun = (data) => reject(data)
        this.dialogVisible = true
        this.source = source
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            account: this.formData.account,
            password: this.formData.password,
          }
          this.$store.dispatch('bindAccountWithPassword', params).then(() => {
            this.dialogVisible = false
            this.$message.success('已成功绑定账号')
            resloveFun(true)
          }).catch((msg) => {
            rejectFun(msg)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    clearData() {
      this.formData = {}
    },
  },
}
  </script>
  
  <style lang="scss" scoped>
.content {
  height: Translate(130px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
::v-deep .custom_my_form {
  .el-form-item {
    .el-form-item__label {
      color: #333333;
      padding: 0 15px 0 0;
    }
  }
}
.code {
  position: relative;

  .captcha {
    width: Translate(80px);
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .error {
    position: absolute;
    color: #f56c6c;
    bottom: -35px;
    font-size: Translate(12px);
    line-height: Translate(20px);
    font-weight: 400;
  }

  .get-code {
    position: absolute;
    font-size: Translate(14px);
    color: #0058FF;
    font-weight: 400;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: #fff;
    padding: 0;
  }
}
</style>